export default "__VITE_ASSET__7624bf3c__"